import API from '.';

export default class CountrySubdivision {
  /**
   * The CountrySubdivision dimension table for UDM
   * @param {number} countrY_ID Id of the country.
   * @param {number} countrY_SUBDIVISION_ID Id of the subdivision.
   * @param {string} countrY_SUBDIVISION_NAME Name of the subdivision.
   * @param {string} countrY_SUBDIVISION_CODE Code of the subdivision.
   */
  constructor({
    countrY_ID,
    countrY_SUBDIVISION_ID,
    countrY_SUBDIVISION_NAME,
    countrY_SUBDIVISION_CODE,
  }) {
    this.countrY_ID = countrY_ID;
    this.countrY_SUBDIVISION_ID = countrY_SUBDIVISION_ID;
    this.countrY_SUBDIVISION_NAME = countrY_SUBDIVISION_NAME;
    this.countrY_SUBDIVISION_CODE = countrY_SUBDIVISION_CODE;
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get('/countrySubdivision');
    return data.map((d) => new CountrySubdivision(d));
  }

  static async getByCountryId(countryId) {
    const api = await API();
    return api.get(`/countrySubdivision?countryId=${countryId}`);
  }

  static async get(id) {
    const api = await API();
    return api.get(`countrySubdivision/${id}`);
  }

  static async create(data) {
    const api = await API();
    return api.post('countrySubdivision', data);
  }

  static async update(id, data) {
    const api = await API();
    return api.put(`/countrySubdivision`, data);
  }

  static async remove(id) {
    const api = await API();
    return api.delete(`/countrySubdivision/${id}`);
  }
}
